package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class FileType(private val literal: String) : IEnumType {
	NA("NA"),
	头像("头像"),
	图片("图片"),
	照片附件("照片附件");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "file_type"}
	override fun getLiteral(): String {return literal}
}
